import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Utils from "~/helpers/Utils";
import SchedulingFilter from "~/components/common/schedulingReport/SchedulingFilter";
import travelsReportAction from "~/actions/reporting/travelsReportAction";
import "~/components/reporting/Reporting.scss";

const TravelsFilterScheduled = (props) => {
    const dispatch = useDispatch();

    const { edition } = useSelector((state) => state.travelsReport.scheduling);

    const onFormRefUpdate = useCallback((_scheduledForm) => {
        dispatch(travelsReportAction.updateScheduleForm(_scheduledForm.current));
    }, [dispatch])

    return (
        <SchedulingFilter
            edition={edition}
            onFormRefUpdate={onFormRefUpdate}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                dispatch(
                    travelsReportAction.saveTravelsReportScheduling(
                        {
                            Id: values.Id,
                            PeriodicidadeDia: values.PeriodicidadeDia,
                            Formato: values.Formato,
                            Email: values.Email,
                            DataInicio: moment(values.DataInicio).format("DD/MM/YYYY"),
                            ObjetoRastreavelId: parseInt(values.ObjetoRastreavel.id),
                        },
                        (error, res) => {
                            setSubmitting(false);

                            if (error) {
                                Utils.showAllErrors(error);
                                return;
                            }

                            resetForm();

                            dispatch(travelsReportAction.getTravelsReportScheduling({}));
                            dispatch(travelsReportAction.getTravelsReportSent({}));
                            dispatch(travelsReportAction.finishEditionTravelsReportScheduling());
                        }
                    )
                );
            }}
        />
    );
};

export default TravelsFilterScheduled;
